// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1rnen","obliqueLineWrap":"membershipbadge_obliqueLineWrap__UdNHg","obliqueLine":"membershipbadge_obliqueLine__22UAW"};